module.exports = __webpack_public_path__ + "static/media/tree-state-3.ae8f7c9d.wav";